import React from 'react';
import { ListGroup, ListGroupItem, Button, Card } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useParams } from 'react-router-dom';
import { sortBy } from 'lodash';
import { useFetch, PageTitle, PseudoStates } from '@cordata/buffet';

import ListGroupItemReminders from '~/components/Reminder/ListGroupItem';

const RemindersIndex = () => {
  const params = useParams();
  const [status, data] = useFetch(`/patients/${params.patient_id}/reminders`);

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            size="sm"
            to={`/patients/${params.patient_id}/reminders/add`}
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Reminder</span>
          </Button>
        }
      >
        Reminders
      </PageTitle>

      <Card>
        {status === 'success' ? (
          <ListGroup flush>
            {data.length ? sortBy(data.filter(r => !r.isRead), ['reminderDate']).reverse().map(d => (
              <ListGroupItemReminders
                key={d.id}
                data={d}
                params={params}
              />
            )) : (
              <ListGroupItem>
                No Reminders
              </ListGroupItem>
            )}
          </ListGroup>
        ) : (
          <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
        )}
      </Card>
    </>
  );
};

export default RemindersIndex;
